import { combineReducers } from 'redux';
import entitiesReducer from 'entities-reducer';
import {
  loadingOverlayReducer as loadingPromises,
} from '../redux-modules/loading-overlay';
import createPromisesReducer from '../redux-modules/pending-promises';
import { legislatorsReducer } from '../App/account/actions/legislators';
import { surveysReducer } from '../App/account/actions/surveys';
import accountUserReducer from './accountUserReducer';

const rootReducer = combineReducers({
  currentUser: accountUserReducer,
  loadingPromises,
  entities: entitiesReducer(
    {
      legislators: legislatorsReducer,
      surveys: surveysReducer,
    }
  ),
  pendingPromises: createPromisesReducer(),
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js